/**
 * Voluum tracker API / merged row keys only (camelCase + common snake fallbacks).
 * Binom columns are normalized on the server — see binom-dashboard-mapping.constants.ts.
 */

export const VOLUUM_METRIC_ALIASES: Record<string, string[]> = {
  impressions: ['impressions', 'sends'],
  uniqueVisits: ['uniqueVisits', 'visits'],
  uniqueClicks: ['uniqueClicks', 'unique_clicks'],
  conversions: ['conversions', 'leads'],
  customConversions6: ['customConversions6', 'event_1', 'leads'],
  customConversions7: ['customConversions7', 'ftd', 'event_2'],
  CPL: ['CPL', 'cpl'],
  epl: ['epl', 'EPL'],
};
